const DESCRIPTION_FILTER_PREFIX = 'gh_filter_';

const datasetKeyForField = (field) =>
  `ghFilter${field.replace(/(^|_)([a-z])/g, (_, __, char) => char.toUpperCase())}`;

const getSelectedFilters = () => {
  const filters = new Map();
  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of params.entries()) {
    if (!key.startsWith(DESCRIPTION_FILTER_PREFIX)) continue;

    const field = key.replace(DESCRIPTION_FILTER_PREFIX, '');
    if (!filters.has(field)) filters.set(field, new Set());
    filters.get(field).add(value);
  }

  return filters;
};

const syncInputs = () => {
  const filters = getSelectedFilters();

  document.querySelectorAll('[data-gh-description-filter]').forEach((input) => {
    if (!(input instanceof HTMLInputElement)) return;

    const field = input.dataset.ghFilterField;
    const value = input.dataset.ghFilterValue;
    input.checked = Boolean(field && value && filters.get(field)?.has(value));
  });
};

const updateFacetStatus = () => {
  document.querySelectorAll('.gh-description-filters__item').forEach((item) => {
    const status = item.querySelector('facet-status-component span[ref="facetStatus"]');
    if (!(status instanceof HTMLElement)) return;

    const count = item.querySelectorAll('input[data-gh-description-filter]:checked').length;
    status.textContent = count > 0 ? String(count) : '';
  });
};

const applyDescriptionFilters = () => {
  const filters = getSelectedFilters();
  const activeFields = [...filters.entries()].filter(([, values]) => values.size > 0);

  document.querySelectorAll('.product-grid__item').forEach((card) => {
    if (!(card instanceof HTMLElement)) return;

    const isMatch = activeFields.every(([field, values]) => {
      const productValue = card.dataset[datasetKeyForField(field)];
      return productValue && values.has(productValue);
    });

    card.classList.toggle('gh-description-filter-hidden', activeFields.length > 0 && !isMatch);
  });

  syncInputs();
  updateFacetStatus();
};

const updateUrlFromInput = (input) => {
  const field = input.dataset.ghFilterField;
  const value = input.dataset.ghFilterValue;
  if (!field || !value) return;

  const url = new URL(window.location.href);
  const key = `${DESCRIPTION_FILTER_PREFIX}${field}`;
  const values = url.searchParams.getAll(key).filter((item) => item !== value);

  url.searchParams.delete(key);
  if (input.checked) values.push(value);
  values.forEach((item) => url.searchParams.append(key, item));
  url.searchParams.delete('page');

  window.history.pushState({}, '', url);
};

let applyQueued = false;
const queueApplyDescriptionFilters = () => {
  if (applyQueued) return;

  applyQueued = true;
  requestAnimationFrame(() => {
    applyQueued = false;
    applyDescriptionFilters();
  });
};

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('[data-gh-description-filter]')) return;

  updateUrlFromInput(input);
  applyDescriptionFilters();
});

window.addEventListener('popstate', queueApplyDescriptionFilters);
window.addEventListener('scroll', queueApplyDescriptionFilters, { passive: true });
document.addEventListener('DOMContentLoaded', queueApplyDescriptionFilters);
document.addEventListener('shopify:section:load', queueApplyDescriptionFilters);
